export type RequestStateType = {
    PENDING: 1,
    IDLE: 2,
    ERROR: 3
}
export const REQUEST_STATE = {
    PENDING: 1,
    IDLE: 2,
    ERROR: 3,
}